import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import overviewIconOn from '../../images/components/content_summary/overview_icon_on.svg';
import overviewIconOff from '../../images/components/content_summary/overview_icon_off.svg';
import componentIconOn from '../../images/components/content_summary/component_icon_on.svg';
import componentIconOff from '../../images/components/content_summary/component_icon_off.svg';
import securityIconOn from '../../images/components/content_summary/security_icon_on.svg';
import securityIconOff from '../../images/components/content_summary/security_icon_off.svg';
import licenseIconOn from '../../images/components/content_summary/license_icon_on.svg';
import licenseIconOff from '../../images/components/content_summary/license_icon_off.svg';
import policyIconOn from '../../images/components/content_summary/policy_icon_on.svg';
import policyIconOff from '../../images/components/content_summary/policy_icon_off.svg';

class HeaderLink extends Component {
  render() {
    const activeClassName = 'active';
    const { t } = this.props;

    return (
      <nav className="result_header_menu">
        <NavLink
          to="/results/overview"
          className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
        >
          <p className="icon">
            <img className="on" src={overviewIconOn} alt="Overview" />
            <img className="off" src={overviewIconOff} alt="Overview" />
          </p>
          <p className="menu_name">{t('panel.menu.overview')}</p>
        </NavLink>
        <NavLink
          to="/results/component"
          className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
        >
          <p className="icon">
            <img className="on" src={componentIconOn} alt="Component" />
            <img className="off" src={componentIconOff} alt="Component" />
          </p>
          <p className="menu_name">{t('panel.menu.component')}</p>
        </NavLink>
        <NavLink
          to="/results/security"
          className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
        >
          <p className="icon">
            <img className="on" src={securityIconOn} alt="Security" />
            <img className="off" src={securityIconOff} alt="Security" />
          </p>
          <p className="menu_name">{t('panel.menu.security')}</p>
        </NavLink>
        <NavLink
          to="/results/license"
          className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
        >
          <p className="icon">
            <img className="on" src={licenseIconOn} alt="License" />
            <img className="off" src={licenseIconOff} alt="License" />
          </p>
          <p className="menu_name">{t('panel.menu.license')}</p>
        </NavLink>
        <NavLink
          to="/results/policy"
          className={({ isActive }) => { return (isActive ? activeClassName : undefined); }}
        >
          <p className="icon">
            <img className="on" src={policyIconOn} alt="Policy" />
            <img className="off" src={policyIconOff} alt="Policy" />
          </p>
          <p className="menu_name">{t('panel.menu.policy')}</p>
        </NavLink>
      </nav>
    );
  }
}
export default WithRouter(withTranslation()(HeaderLink));
